<div class="extraction-summary-container">

  <!-- Header -->
  <div class="header">
    <button class="btn-back" (click)="goBack()">← {{ 'extractionSummary.back' | translate }}</button>
    <h2 class="page-title">{{ 'extractionSummary.title' | translate }}</h2>
  </div>

  <!-- Error with retry -->
  <div class="error-message" *ngIf="error">
    {{ error }}
    <button class="btn-retry" (click)="loadData()">{{ 'extractionSummary.retry' | translate }}</button>
  </div>

  <!-- Loading -->
  <div class="loading" *ngIf="loading">{{ 'dossier.loading' | translate }}</div>

  <!-- Not ready — polling spinner -->
  <div class="waiting-banner" *ngIf="!loading && !error && !isExtractionDone">
    <div class="waiting-spinner"></div>
    <span>{{ 'extractionSummary.notReady' | translate }}</span>
  </div>

  <!-- Summary table -->
  <table class="summary-table" *ngIf="!loading && isExtractionDone && documents.length > 0">
    <thead>
      <tr>
        <th>{{ 'extractionSummary.filename' | translate }}</th>
        <th>{{ 'extractionSummary.docNumber' | translate }}</th>
        <th>{{ 'extractionSummary.docType' | translate }}</th>
        <th>{{ 'extractionSummary.confidence' | translate }}</th>
        <th>{{ 'extractionSummary.status' | translate }}</th>
        <th>{{ 'extractionSummary.tokens' | translate }}</th>
        <th>{{ 'extractionSummary.actions' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of documents; let i = index">
        <td>{{ upload?.original_filename }}</td>
        <td>{{ i + 1 }}</td>
        <td>{{ doc.document_type }}</td>
        <td>
          <span class="confidence-badge" *ngIf="doc.confidence != null"
                [class.green]="doc.confidence > 0.95"
                [class.light-green]="doc.confidence > 0.90 && doc.confidence <= 0.95"
                [class.yellow]="doc.confidence > 0.85 && doc.confidence <= 0.90"
                [class.orange]="doc.confidence >= 0.80 && doc.confidence <= 0.85"
                [class.red]="doc.confidence < 0.80">
            {{ doc.confidence * 100 | localNumber:'1.0-0' }}%
          </span>
          <span *ngIf="doc.confidence == null">—</span>
        </td>
        <td>
          <span class="status-badge" [attr.data-status]="doc.status">{{ doc.status }}</span>
        </td>
        <td>
          <span *ngIf="getExtractionTokens(doc) !== null">{{ getExtractionTokens(doc) }}</span>
          <span *ngIf="getExtractionTokens(doc) === null">—</span>
        </td>
        <td>
          <button
            class="btn-icon"
            (click)="openDetail(doc)"
            [title]="'extractionSummary.viewDetail' | translate"
            aria-label="View extraction detail"
          >👁</button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!loading && isExtractionDone && documents.length === 0">
    {{ 'extractionSummary.noDocuments' | translate }}
  </div>

</div>
